import ListIcon from '@mui/icons-material/List'
import { Button, CircularProgress, Drawer, Stack } from '@mui/material'
import { FC } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import { DataFetchErrorWithRetry } from 'src/features/error/DataFetchErrorWithRetry'
import { gray } from 'src/features/muikds/kdsColors'
import { useDrawerState } from '../../../hooks/useDrawerState'
import { useQueryMasterFieldDefsByMasterUuid } from '../../api/useQueryMasterFieldDefsByMasterUuid'
import { MasterFieldDefAddButton } from '../MasterFieldDefAddButton/MasterFieldDefAddButton'
import { MasterFieldDefList } from '../MasterFieldDefList/MasterFieldDefList'

type Props = {
  masterUuid: string
}

export const MasterFieldDefsEditButton: FC<Props> = ({ masterUuid }) => {
  const { isOpen, openDrawer, closeDrawer } = useDrawerState(false)
  return (
    <>
      <Button
        color="secondary"
        size="medium"
        variant="contained"
        startIcon={<ListIcon />}
        onClick={openDrawer}
      >
        項目を編集する
      </Button>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={closeDrawer}
        sx={{
          '& .MuiDrawer-paper': {
            width: 600,
            display: 'grid',
            gridTemplateAreas: `
            "header"
            "content"
            "footer"
          `,
            gridTemplateRows: `auto 1fr auto`,
          },
        }}
      >
        <Header
          style={{
            gridArea: 'header',
          }}
        >
          <HeaderTitle title="項目を編集する" />
        </Header>
        <Stack
          sx={{
            gridArea: 'content',
            overflowY: 'auto',
          }}
        >
          <ErrorBoundary fallbackRender={DataFetchErrorWithRetry}>
            <DrawerContent masterUuid={masterUuid} />
          </ErrorBoundary>
        </Stack>
        <Stack
          direction="row"
          justifyContent="flex-end"
          sx={{
            p: 3,
            borderTop: 1,
            borderColor: 'divider',
            backgroundColor: gray[2],
            gridArea: 'footer',
          }}
        >
          <Button color="secondary" variant="contained" onClick={closeDrawer}>
            閉じる
          </Button>
        </Stack>
      </Drawer>
    </>
  )
}

const DrawerContent: FC<{ masterUuid: string }> = ({ masterUuid }) => {
  const { data, isLoading } = useQueryMasterFieldDefsByMasterUuid(masterUuid)

  if (isLoading) {
    return (
      <Stack sx={{ flex: 1 }} alignItems="center" justifyContent="center">
        <CircularProgress />
      </Stack>
    )
  }

  if (!data) {
    return null
  }

  return (
    <Stack sx={{ height: '100%' }}>
      <Stack
        direction="row"
        justifyContent="flex-end"
        sx={{
          p: 2,
          backgroundColor: gray[2],
        }}
      >
        <MasterFieldDefAddButton masterUuid={masterUuid} fieldDefs={data} />
      </Stack>
      <MasterFieldDefList masterUuid={masterUuid} fieldDefs={data} />
    </Stack>
  )
}
